import { EmploymentType } from '@types';
import { HqApiService } from 'hq/services/hqApiService';
import { OgpApiService } from 'ogp/services/ogp-api-service';
import { Site } from 'shared/hooks';
import { WorkerForSelect } from './workers-service.dto';

export class WorkersService {
  constructor(
    private readonly hqApiService: HqApiService,
    private readonly ogpApiService: OgpApiService
  ) {}
  public async getWorkerList(
    search: string,
    site: Site,
    employmentTypes?: EmploymentType[]
  ): Promise<WorkerForSelect[]> {
    if (site === 'hq') {
      return await this.hqApiService.get<WorkerForSelect[]>({
        path: `flex-workers/worker-list`,
        params: {
          search,
          employmentTypes: employmentTypes ?? ['FREELANCER', 'TEMPWORKER'],
        },
      });
    }
    if (site === 'ogp') {
      return await this.ogpApiService.get<WorkerForSelect[]>({
        path: `workforce/worker-list`,
        params: {
          search,
          employmentTypes,
        },
      });
    }

    throw new Error('Not yet implemented');
  }
}
